module.exports = __webpack_public_path__ + "static/TWAUS-brand-banner-desktop-f2d1f5d20a206675b0352571bf115355.png";